/**
 * Download file by URL.
 * NOTE: taken from https://stackoverflow.com/a/43523297/7013346
 * @param url The URL of the file to download.
 * @param name The name of the file.
 */
export function downloadFileUrl(url: URL | string, name = '') {
  const a = document.createElement('a');
  a.href = url.toString();
  a.download = name;
  a.target = '_blank';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
